import * as React from 'react';

import classnames from 'classnames';

import styles from './slack-message-preview.module.css';

type Props = {
    slackMessagePreviewTopRowText?: string;
};

export function SlackMessagePreviewContent(props: Props) {
    return (
        <div className={styles['preview-card-form-submission']}>
            <div className={classnames(styles['accent-bar'], styles['accent-bar-open'])} />
            <div className={styles['preview-card-lead-info']}>
                <div className={styles['preview-card-attributes']}>
                    {props.slackMessagePreviewTopRowText ? (
                        <h5>{props.slackMessagePreviewTopRowText}</h5>
                    ) : undefined}
                    <div>
                        <h5>Name</h5>
                        Charles Berry
                    </div>
                    <div>
                        <h5>Email address</h5>
                        cberry@arrowgrid.com
                    </div>
                </div>
            </div>
        </div>
    );
}
